import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { FeatureCardComponent } from '../feature-card/feature-card.component';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-service-directions',
  imports: [SectionWrapperComponent, FeatureCardComponent, CtaButtonComponent],
  templateUrl: './service-directions.component.html',
  styleUrl: './service-directions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDirectionsComponent {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly featureFlags = inject(FeatureFlagService);

  readonly section = computed(() => {
    this.featureFlags.flags();
    const data = this.siteConfig.serviceDirections();
    if (!data) {
      return null;
    }
    return { ...data, items: this.featureFlags.filterItems(data.items) };
  });
}
